import { ILocationModel } from '../models/api_models';

export default (location: ILocationModel): string | undefined => {
  if (!location) return undefined;
  const { query, keyName, keyValue } = location;

  const url = new URL('https://geois.corp.axpo.com/weboffice-mobile/synserver');
  url.searchParams.set('project', 'mobile');
  url.searchParams.set('client', 'flex');
  if (query) url.searchParams.set('query', query);
  if (keyName) url.searchParams.set('keyName', keyName);
  if (keyValue) url.searchParams.set('keyValue', keyValue);
  url.searchParams.set('mode', 'zoom_to');

  return url.toString();
};
